import { SVGProps } from "react";

const Philippines = (props: SVGProps<SVGSVGElement>) => {
  const { width = 24, height = 24 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="#F0F0F0"
      />
      <path
        d="M12 2V12L4.92889 19.0711C6.73854 20.8807 9.23854 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47719 12 2 12 2Z"
        fill="#D80027"
      />
      <path
        d="M12 2C9.23854 2 6.73854 3.1193 4.92889 4.92891C7.38241 7.38242 8.25339 8.25344 12 12H22C22 6.47719 17.5228 2 12 2Z"
        fill="#0052B4"
      />
      <path
        d="M8.8473 12L7.62605 11.4255L8.2764 10.2428L6.95023 10.4965L6.78219 9.15674L5.85844 10.1421L4.93472 9.15674L4.76664 10.4965L3.44051 10.2427L4.09086 11.4255L2.86957 12L4.09086 12.5744L3.44051 13.7572L4.76676 13.5035L4.93468 14.8432L5.85844 13.8579L6.78219 14.8432L6.95023 13.5035L8.27633 13.7572L7.62601 12.5745L8.8473 12Z"
        fill="#FFDA44"
      />
      <path
        d="M4.66691 5.91309L5.07332 6.48117L5.73914 6.27027L5.32437 6.8323L5.73078 7.40039L5.06805 7.17965L4.65332 7.74164L4.65851 7.0432L3.99582 6.82242L4.66176 6.61152L4.66691 5.91309Z"
        fill="#FFDA44"
      />
      <path
        d="M4.66691 16.2585L5.07332 16.8266L5.73914 16.6157L5.32437 17.1778L5.73078 17.7458L5.06805 17.5251L4.65332 18.0871L4.65851 17.3887L3.99582 17.1679L4.66176 16.957L4.66691 16.2585Z"
        fill="#FFDA44"
      />
      <path
        d="M10.4635 11.0857L10.0572 11.6538L9.3913 11.4428L9.80606 12.0049L9.39966 12.573L10.0624 12.3522L10.4772 12.9142L10.4719 12.2158L11.1346 11.995L10.4687 11.7841L10.4635 11.0857Z"
        fill="#FFDA44"
      />
    </svg>
  );
};

export default Philippines;
